import {
  Box,
  FormControl,
  Input,
  InputLabel,
  MenuItem,
  Select,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { PlanoButton, PlanoDropDownMenu } from "../../../Common";
import "./PlanoSelectCard.css";
import { BiStoreAlt } from "react-icons/bi";
import { HiOutlineChip } from "react-icons/hi";
import PlanoTabsCard from "./PlanoTabsCard";
import { MdDriveFolderUpload } from "react-icons/md";
import "./PlanoSelectCard.css";
import { useSelector } from "react-redux";
import { getData } from "../../../Hooks/apiCalls";
const PlanoSelectCard = ({
  screen,
  setScreen,
  selectData,
  setSelectData,
  selectedVisualizationData,
  getdeptdetails,
  departmentData,
  selectedBay,
  handleChangeForBay,
  generateImageFunction,
  getbayitems,
  bayItemsData = [],
  imageSource = "",
  setSelectedBay,
}) => {
  const date = new Date(selectedVisualizationData.versiondate);
  const month = date.getMonth() + 1; // months from 1-12
  const day = date.getUTCDate();
  const year = date.getUTCFullYear();
  const newDate = `${year}-${month}-${day}`;
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm")); // Adjust breakpoint as needed

  const [screenChange, setScreenChange] = useState("prodData");
  const [selectedDepartment, setSelectedDepartment] = useState("");

  const handleChangeForDepartment = (e) => {
    setSelectData(e.target.value);
    setSelectedDepartment(e.target.value);
    handleDepSelectedData(e.target.value);
  };

  const [depBayData, setDepBayData] = useState([]);

  const handleDepSelectedData = (value) => {
    departmentData?.map((elem) => {
      if (Object.keys(elem)[0] === value) {
        setDepBayData(Object.values(elem)[0]);
      }
    });
  };

  useEffect(() => {
    if (selectedVisualizationData !== "New Visualization") {
      getdeptdetails(newDate);
    }
  }, []);
  return (
    <Box
      bgcolor={"white"}
      p={2}
      // height={{ lg: "560px", md: "490px", xl: "720px" }}
      width={isSmallScreen ? "auto" : "30%"}
      borderRadius={"12px"}
      position={"relative"}
      sx={{
        boxShadow:
          "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
      }}
      height={"82vh"}
    >
      <Box textAlign={"center"} height={"10%"}>
        <PlanoButton
          css={{
            fontSize: " 24px",
            fontWeight: "400",
            lineHeight: "36px",
            letterSpacing: "0em",
            backgroundColor: "white",
            color: screenChange !== "prodData" ? "lightgrey" : "black",
            ":hover": { backgroundColor: "white" },
          }}
          mainfunction={() => {
            setScreenChange("prodData");
          }}
        >
          Product Data
        </PlanoButton>
      </Box>
      {screenChange === "prodData" ? (
        <Box height={"70%"}>
          <Box display={"flex"} gap={2} mb={2}>
            <FormControl
              fullWidth
              variant="filled"
              sx={{
                marginTop: "1rem",
                borderRadius: "20px",
              }}
              size="small"
            >
              <InputLabel
                sx={{
                  color: "black",
                  display: "flex",
                }}
              >
                <span>
                  <BiStoreAlt
                    style={{
                      marginRight: 8,
                      marginTop: 1,
                      color: "black",
                      fontSize: "1.3rem",
                    }}
                  />
                </span>
                <span>Department</span>
              </InputLabel>
              <Select
                value={selectData}
                label={selectData}
                onChange={(e) => {
                  handleChangeForDepartment(e);
                }}
                sx={{
                  borderRadius: "8px",
                  backgroundColor: "#f3f7f9",
                }}
              >
                {departmentData?.map((elem, index) => {
                  return (
                    <MenuItem value={Object.keys(elem)[0]}>
                      {Object.keys(elem)[0]}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <PlanoDropDownMenu
              menuOptions={depBayData}
              handleChange={handleChangeForBay}
              value={selectedBay}
            >
              <span>
                <HiOutlineChip
                  style={{
                    marginRight: 8,
                    marginTop: 1,
                    color: "black",
                    fontSize: "1.3rem",
                  }}
                />
              </span>
              <span>Bay</span>
            </PlanoDropDownMenu>
          </Box>

          <Box
            height={"100%"}
            overflow={"scroll"}
            borderTop={"1px solid black"}
            borderBottom={"1px solid black"}
          >
            {bayItemsData?.length !== 0 && (
              <>
                {bayItemsData?.map((elem, inde) => (
                  <PlanoTabsCard data={elem} />
                ))}
              </>
            )}
          </Box>
        </Box>
      ) : (
        <>
          <Box
            mt={2}
            height={"212px"}
            sx={{
              textAlign: "center",
              fontSize: "1.3rem",
              border: "1px solid black",
              position: "relative",
              backgroundColor: "#F3F7F9",
            }}
          >
            <Input
              type="file"
              name="file-input"
              id="file-input"
              sx={{
                display: "none",
              }}
            />
            <label
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
              id="file-input-label"
              for="file-input"
            >
              Upload from local/Drag and drop
              <br />
              <span>
                <MdDriveFolderUpload
                  style={{
                    fontSize: "2rem",
                  }}
                />
              </span>
            </label>
          </Box>
        </>
      )}

      <Box height={"10%"} mt={"1rem"}>
        {screenChange === "prodData" ? (
          <PlanoButton
            mainfunction={() => {
              generateImageFunction();
              getbayitems();
            }}
            // dissable={imageSource !== ""}
            css={{
              position: "absolute !important",
              left: 12,
              bottom: 12,
              backgroundColor: "#f04e23 !important",
              color: "white",
              ":hover": { backgroundColor: "#f04e23 !important " },
              ":disabled": { color: "white" },
            }}
          >
            Generate Image
          </PlanoButton>
        ) : (
          <PlanoButton
            css={{
              position: "absolute",
              left: 12,
              bottom: 12,
              backgroundColor: "#f04e23 !important",
              color: "white",
              ":hover": { backgroundColor: "#f04e23 !important" },
            }}
          >
            Import
          </PlanoButton>
        )}
        <PlanoButton
          css={{
            position: "absolute",
            left: 200,
            bottom: 12,
            backgroundColor: "#f04e23 !important",
            color: "white",
            ":hover": { backgroundColor: "#f04e23 !important" },
          }}
          mainfunction={() => {
            setScreen("");
            setSelectData("");
            setSelectedBay("");
          }}
        >
          Go Back
        </PlanoButton>
      </Box>
    </Box>
  );
};

export default PlanoSelectCard;
